module.exports = __webpack_public_path__ + "img/amex.6df6d971.png";